/** Prueba aislada: jornada conversacional. No forma parte del perfil EF. */

export function showJornadaGuiaTrial(user) {
    try {
        if (typeof localStorage !== 'undefined' && localStorage.getItem('alinea_hide_jornada_guia') === '1') {
            return false;
        }
    } catch {
        /* ignore */
    }
    const slug = String(user?.tenantSlug || user?.tenant_slug || '').toLowerCase();
    if (slug === 'c-es' || slug === 'qfsas') return true;
    return Boolean(import.meta.env.DEV);
}

export function firstNameOfUser(user) {
    const raw = String(user?.nombre_completo || user?.full_name || user?.name || '').trim();
    return raw.split(/\s+/)[0] || '';
}

export { matchVoiceOption } from '../utils/voiceUx.js';

export const GUIA_LLEGADA = [
    { key: 'bien', emoji: '😊', label: 'Bien', feeling: 'bien', reason: null, voice: ['bien', 'bueno', 'ok', 'tranquilo', 'eje'] },
    { key: 'cansado', emoji: '😐', label: 'Cansado', feeling: 'regular', reason: null, voice: ['cansado', 'cansada', 'regular', 'esfuerzo'] },
    { key: 'saturado', emoji: '😣', label: 'Saturado', feeling: 'mal', reason: 'bateria', voice: ['saturado', 'saturada', 'agotado', 'bateria'] },
    { key: 'tenso', emoji: '⚡', label: 'Tenso', feeling: 'mal', reason: 'tension', voice: ['tenso', 'tensa', 'tension', 'estres'] },
];

export const GUIA_AYUDA = [
    { key: 'claridad', label: 'Claridad', emoji: '🧭', voice: ['claridad', 'claro'] },
    { key: 'apoyo', label: 'Apoyo', emoji: '🤝', voice: ['apoyo', 'ayuda'] },
    { key: 'pausa', label: 'Pausa', emoji: '😴', voice: ['pausa', 'parar', 'descanso'] },
    { key: 'conversar', label: 'Conversar', emoji: '💬', voice: ['conversar', 'hablar', 'charlar'] },
];

export const GUIA_EPA = [
    { key: 'bien', label: 'Estoy bien', emoji: '🙂', voice: ['bien'] },
    { key: 'regular', label: 'Me estoy esforzando', emoji: '💪', voice: ['esforzando', 'regular'] },
    { key: 'mal', label: 'Necesito parar', emoji: '🛑', voice: ['parar', 'mal'] },
    { key: 'sick', label: 'Indispuesto', emoji: '🤒', voice: ['indispuesto', 'indispuesta', 'enfermo', 'enferma'] },
];

export const GUIA_FATIGA = [
    { key: 'no_bien', label: 'Con fuerza', emoji: '💪', voice: ['fuerza'] },
    { key: 'un_poco', label: 'Algo cansado', emoji: '📈', voice: ['algo', 'un poco'] },
    { key: 'muy_cansado', label: 'Agotado', emoji: '🛑', voice: ['agotado', 'muy cansado'] },
];

export const GUIA_CIERRE = [
    { key: 'valio_la_pena', label: 'Valió la pena', emoji: '✨', voice: ['valio', 'pena'] },
    { key: 'sin_ganas', label: 'Sin energía', emoji: '📉', voice: ['sin energia', 'sin ganas'] },
];

export function openingLine(name) {
    const n = name ? `, ${name}` : '';
    return `Buen día${n}. Esta es una prueba: mismas preguntas de la jornada, en conversación. ¿Cómo llegas hoy?`;
}

const HABIT_KEY = 'alinea_epa_habit';

export function bumpEpaPauseHabit() {
    const today = new Date().toISOString().slice(0, 10);
    let rec = { days: [] };
    try {
        rec = JSON.parse(localStorage.getItem(HABIT_KEY) || '{"days":[]}');
    } catch {
        rec = { days: [] };
    }
    const days = Array.isArray(rec.days) ? rec.days : [];
    if (!days.includes(today)) days.push(today);
    rec.days = days.slice(-40);
    rec.lastPauseAt = new Date().toISOString();
    localStorage.setItem(HABIT_KEY, JSON.stringify(rec));
    return rec.days.length;
}

export function setEpaHabitReminder(on) {
    try {
        const rec = JSON.parse(localStorage.getItem(HABIT_KEY) || '{}');
        rec.remindInShift = !!on;
        rec.remindSetAt = new Date().toISOString();
        localStorage.setItem(HABIT_KEY, JSON.stringify(rec));
    } catch {
        /* ignore */
    }
}

export const VOICE_SIGNAL_KEY = 'alinea_voice_change_signals';

export function storeLocalVoiceSignal(indices, quality) {
    try {
        const prev = JSON.parse(localStorage.getItem(VOICE_SIGNAL_KEY) || '[]');
        prev.push({
            at: new Date().toISOString(),
            intensity: indices?.intensity ?? indices?.rmsMean,
            depth: indices?.depth,
            shimmerProxy: indices?.shimmerProxy,
            qualityOk: !!quality?.ok,
        });
        localStorage.setItem(VOICE_SIGNAL_KEY, JSON.stringify(prev.slice(-60)));
    } catch {
        /* ignore */
    }
}
